import { useRouter } from 'next/router';
import { useMemo } from 'react';
import useCardDetailsApi from 'hooks/queries/cards/useCardsDetailsApi';
import { CARD_TYPE_API_REF } from 'types/modifiers/references';
import { useCmsData } from 'utils/cms';
import queryParamsChoicesToTabs from 'utils/cms/queryParamsChoicesToTabs';
import useCardTranslation from './useCardTranslation';

const useCardDetails = () => {
  const {
    acf: { queryParameters },
    url,
    generalSettings,
  } = useCmsData();
  const {
    query: { slug },
    push,
  } = useRouter();
  const reference = slug && slug[1];
  const { card, status, lore } = useCardDetailsApi(reference || '');

  if (!card && status === 'success') {
    push('/404');
  }

  const tabs = useMemo(() => {
    const tabsParams = queryParameters.find((param) => param.name === 'tabs_details');
    let allparam = tabsParams ? queryParamsChoicesToTabs(tabsParams, `${url}/${reference}` || '') : [];
    if (card && card.cardType?.reference === CARD_TYPE_API_REF.FOILER) {
      allparam = allparam.filter((param) => param.value !== 'lore');
    }
    if (!generalSettings.marketplace) {
      allparam = allparam.filter((param) => param.value !== 'offers');
    }

    return allparam;
  }, [queryParameters]);
  const currTab = useMemo(() => slug?.[2] || '', [slug]);

  const { languagesItems, currentLang } = useCardTranslation(reference || '');

  return { card, currTab, tabs, lore, languagesItems, currentLang };
};

export default useCardDetails;
